import {Flex} from '@priority-software/priority-style-react';
import React from 'react';
import texts from '../../../texts';
import styles from '../../../styles.module.scss';
import AxisSelector from './AxisSelector';
import {bubbleConfigInfo, chartConfigInfo} from '../../../consts';
import AxisInput from './AxisInput';
import {reportGeneratorsStore} from '../../../stores/ReportGeneratorsStore';
import {getYAxisPlaceHolderByType} from '../../../utils';

const YAxisSection = ({numericColumns, chartInfo, updateChartConfig, yAsMeasure}) => {
    const {isBubble, isGauge, isKpi} = reportGeneratorsStore?.currentScreen;

    const minY = chartInfo.bubbleConfig?.[bubbleConfigInfo.minY];
    const maxY = chartInfo.bubbleConfig?.[bubbleConfigInfo.maxY];
    const isError = minY && maxY && Number(minY) > Number(maxY);

    const getYTitle = () => {
        switch (true) {
            case isGauge:
                return texts.measuredValue;
            case isKpi:
                return texts.kpiValue;
            case yAsMeasure:
                return texts.yAxisMeasure;
            default:
                return texts.yAxis;
        }
    };
    const yTitle = getYTitle();
    return (
        <Flex direction="row" justifyContent="flex-start">
            <AxisSelector
                axisName={chartInfo.yAxis?.Title || ''}
                title={yTitle}
                options={numericColumns}
                onSelect={e => updateChartConfig(chartConfigInfo.yAxis, e)}
                helpText={texts.yAxisHelp}
                placeholder={getYAxisPlaceHolderByType(chartInfo.type)}
            />
            {isBubble && (
                <AxisInput
                    title={texts.minimumY}
                    value={minY || ''}
                    onChange={e => updateChartConfig(bubbleConfigInfo.minY, e.target.value)}
                    compClass={styles.bubbleInp}
                    helpText={texts.minAxisValue}
                    placeholder={texts.bubbleYAxisStartRange}
                    maxLength={10}
                    isError={isError}
                />
            )}
            {isBubble && (
                <AxisInput
                    title={texts.maximumY}
                    value={maxY || ''}
                    onChange={e => updateChartConfig(bubbleConfigInfo.maxY, e.target.value)}
                    compClass={null}
                    helpText={texts.maxAxisValue}
                    placeholder={texts.bubbleYAxisEndRange}
                    maxLength={10}
                />
            )}
        </Flex>
    );
};

export default YAxisSection;
